import { Box, Container, Grid, Typography, Link, IconButton } from "@mui/material";
import { Facebook, LinkedIn, YouTube, WhatsApp, Call, Instagram } from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";

const Footer = () => {
  return (
    <Box
      sx={{
        bgcolor: "#f9f9f9",
        py: 5,
        mt: 4,
        borderTop: "3px solid #673ab7",
        boxShadow: "0px -4px 10px rgba(0,0,0,0.1)"
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4} justifyContent="space-between">
          {/* Left Section - Logo & Description */}
          <Grid item xs={12} md={3.5}>
            <Typography variant="h6" sx={{ fontWeight: "bold", color: "#ff9800" }}>
              Cloud <span style={{ color: "#673ab7" }}>Upskill</span>
            </Typography>
            <Typography variant="body2" sx={{ mt: 1, color: "#444", lineHeight: 1.6 }}>
              We provide instructor-led, live, online IT-based software training, including Informatica, IDMC, Python, Snowflake, and more.
            </Typography>

            {/* Social Icons */}
            <Box sx={{ display: "flex", gap: 1.5, mt: 3 }}>
              <IconButton
                component="a"
                href="https://www.facebook.com/people/Cloud-Upskill/pfbid02wLFkKqatTKAF8dBUTckTgJdCLhYnpJeJcfaqww1V19zDvquoDryE6qBAtQcAr8ndl/"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  color: "#3b5998",
                  "&:hover": { transform: "scale(1.2)", transition: "0.3s" },
                }}
              >
                <Facebook />
              </IconButton>
              <IconButton sx={{ color: "#0077b5", "&:hover": { transform: "scale(1.2)", transition: "0.3s" } }}>
                <LinkedIn />
              </IconButton>
              <IconButton
                component="a"
                href="https://www.youtube.com/@CloudMaster_Abhiram"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  color: "#FF0000",
                  "&:hover": { transform: "scale(1.2)", transition: "0.3s" },
                }}
              >
                <YouTube />
              </IconButton>
              <IconButton
                component="a"
                href="https://www.instagram.com/cloudupskill"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  color: "#E1306C",
                  "&:hover": { transform: "scale(1.2)", transition: "0.3s" },
                }}
              >
                <Instagram />
              </IconButton>
            </Box>

            {/* Contact Numbers */}
            <Box sx={{ display: "flex", alignItems: "center", mt: 2 }}>
              <Call fontSize="small" sx={{ color: "#673ab7", mr: 1 }} />
              <Typography variant="body2" sx={{ color: "#333", fontWeight: "500" }}>
                +91 77806 37278 &nbsp; | &nbsp; +91 63802 54309
              </Typography>
            </Box>
          </Grid>

          {/* Center - Company Links (Moved Right) */}
          <Grid item xs={12} md={3} sx={{ textAlign: "left", pl: 4 }}>
            <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 }}>
              Company
            </Typography>
            <Link href="/" color="inherit" display="block" sx={linkStyle}>Home</Link>
            <Link
              href="/about-us"
              color="inherit"
              display="block"
              sx={linkStyle}
            >
              About Us
            </Link>
            <Link
              href="/contact-us"
              color="inherit"
              display="block"
              sx={linkStyle}
            >
              Contact Us
            </Link>
          </Grid>

          {/* Right - Quick Links (Moved More Right) */}
          <Grid item xs={12} md={3} sx={{ textAlign: "left", pl: 4 }}>
            <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 }}>
              Quick Links
            </Typography>
            <Link href="#" color="inherit" display="block" sx={linkStyle}>Terms & Conditions</Link>
            <Link href="#" color="inherit" display="block" sx={linkStyle}>Privacy Policy</Link>
            <Link href="#" color="inherit" display="block" sx={linkStyle}>Cancellation Policy</Link>
            <Link href="#" color="inherit" display="block" sx={linkStyle}>Refund Policy</Link>
          </Grid>
        </Grid>

        {/* Bottom Copyright & WhatsApp Button */}
        <Box sx={{ mt: 4, textAlign: "center", color: "#555" }}>
          <Typography variant="body2">
            ©2025 - Cloud UpSkill. All Rights Reserved.
          </Typography>
        </Box>

        <IconButton
          component="a"
          href="https://whatsapp.com/channel/0029VbATakoBfxnzpC8Xa03V"
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            position: "fixed",
            bottom: 20,
            right: 20,
            bgcolor: "#25D366",
            color: "#fff",
            p: 2,
            borderRadius: "50%",
            boxShadow: 3,
            transition: "0.3s",
            "&:hover": { transform: "scale(1.2)" }
          }}
        >
          <WhatsApp />
        </IconButton>
      </Container>
    </Box>
  );
};

const linkStyle = {
  color: "#555",
  textDecoration: "none",
  fontSize: "14px",
  fontWeight: "500",
  "&:hover": {
    textDecoration: "underline",
    color: "#673ab7"
  }
};

export default Footer;
